import { makeRequest } from '../../composables/useKftFetch'
import {
  TCourseArticle,
  TCourseParams,
  TCoursesResponse,
  TChaptersResponse,
  TCourseArticleCategory,
  TCreateCourseParams,
  TCreateCourseResponse,
  TChaptersCoursesResponse,
  TCourseArticleCommentsResponse,
  TCreateCourseArticleComment,
  TCreateCourseArticleResponse,
  TSuggestPostResponse,
} from './course.types'

export async function getCourseArticle(slug: string) {
  const data = await makeRequest<TCourseArticle>(
    `/api/course-article/detail/${slug}`,
    {
      transform(course) {
        return Object.assign(course, { content: course.content })
      },
    },
  )
  return data
}

export async function getCourseArticles(
  pickKeys: (keyof TCourseArticleCategory)[] = [],
) {
  const data = await makeRequest<TCourseArticleCategory[]>(
    `/api/course-article/all`,
    {
      params: { fields: pickKeys.join(',') },
    },
  )
  return data
}

export async function getCoursesByCategory(params: TCourseParams) {
  const data = await makeRequest<TCoursesResponse>('api/courses/category', {
    params,
  })
  return data
}

export async function getChaptersBySlug(slug: string) {
  const data = await makeRequest<TChaptersResponse>(
    `api/courses/course/${slug}`,
  )
  return data
}

export async function getSuggestPostsByCourseArticleSlug(slug: string) {
  const data = await makeRequest<TSuggestPostResponse>(
    `api/course-article/suggest-posts/${slug}`,
  )
  return data
}

export async function getSuggestQuestionsByCourseArticleSlug(slug: string) {
  const data = await makeRequest<TSuggestPostResponse>(
    `api/course-article/suggest-question/${slug}`,
  )
  return data
}

export async function postCreateCourses(payload: TCreateCourseParams) {
  const data = await makeRequest<TCreateCourseResponse>(
    '/api/course-article/create',
    {
      method: 'POST',
      body: payload,
    },
  )
  return data
}

export async function putEditCourses(
  payload: TCreateCourseParams,
  slug: string,
) {
  const data = await makeRequest<TCreateCourseResponse>(
    `/api/course-article/update/${slug}`,
    {
      method: 'PUT',
      body: payload,
    },
  )
  return data
}

export async function getChaptersByCoursesSlug(slug: string) {
  const data = await makeRequest<TChaptersCoursesResponse>(
    `api/course-chapter/list`,
    {
      params: { courseSlug: slug },
    },
  )
  return data
}

export async function getCourseArticleComments(slug: string) {
  const data = await makeRequest<TCourseArticleCommentsResponse>(
    `/api/course-article/comments/${slug}`,
  )
  return data
}

export async function courseArticleCreateComment(
  payload: TCreateCourseArticleComment,
) {
  const data = await makeRequest<TCreateCourseArticleResponse>(
    '/api/course-article/comment',
    {
      method: 'POST',
      body: payload,
    },
  )
  return data
}
